import(/* webpackMode: "eager" */ "/vercel/path0/src/app/templates/page.tsx");
